<template>
  <div>
    <div class="d-flex flex-wrap align-center justify-space-between" style="gap: 12px;">
      <h2 class="mb-0">Relatório de JOB</h2>
      <v-btn outlined color="primary" @click="$router.push('/relatorios#comercial')">
        <v-icon left>mdi-arrow-left</v-icon>
        Voltar ao menu
      </v-btn>
    </div>

    <div class="d-flex flex-wrap align-center mt-4 mb-4" style="gap: 12px;">
      <v-text-field v-model="filtros.dataInicio" type="date" label="Abertura inicial" solo hide-details clearable class="c-filtro" />
      <v-text-field v-model="filtros.dataFim" type="date" label="Abertura final" solo hide-details clearable class="c-filtro" />
      <v-text-field v-model="filtros.job" label="JOB" solo hide-details clearable class="c-filtro" />
      <v-text-field v-model="filtros.cliente" label="Cliente" solo hide-details clearable class="c-filtro" />
      <v-text-field v-model="filtros.segmento" label="Segmento" solo hide-details clearable class="c-filtro" />

      <v-btn color="primary" :loading="loading" @click="buscarDados">
        <v-icon left>mdi-refresh</v-icon>
        Recarregar
      </v-btn>

      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" outlined v-on="on" :disabled="loading || dadosFiltrados.length === 0">
            <v-icon left>mdi-file-export-outline</v-icon>
            Exportar
          </v-btn>
        </template>
        <v-list>
          <v-list-item link @click="exportarXlsx"><v-list-item-title>Excel</v-list-item-title></v-list-item>
          <v-list-item link @click="exportarPdfTabela"><v-list-item-title>PDF</v-list-item-title></v-list-item>
        </v-list>
      </v-menu>
    </div>

    <div ref="areaPdf">
      <v-data-table
        :headers="headers"
        :items="dadosFiltrados"
        :loading="loading"
        :expanded.sync="expandidos"
        item-key="_id"
        rows-per-page-text="Linhas por página:"
        page-text="{0}-{1} de {2}"
        class="elevation-1"
        show-expand
      >
        <template v-slot:item.dataAbertura="{ item }">{{ formatarDataPtBr(item.dataAbertura) }}</template>
        <template v-slot:item.dataEncerramento="{ item }">{{ formatarDataPtBr(item.dataEncerramento) }}</template>
        <template v-slot:item.valorJob="{ item }">{{ formatarMoedaPtBr(item.valorJob) }}</template>
        <template v-slot:item.valorRecebido="{ item }">{{ formatarMoedaPtBr(item.valorRecebido) }}</template>
        <template v-slot:item.saldoAReceber="{ item }">{{ formatarMoedaPtBr(item.saldoAReceber) }}</template>
        <template v-slot:item.valorFaturado="{ item }">{{ formatarMoedaPtBr(item.valorFaturado) }}</template>
        <template v-slot:item.saldoEmCarteira="{ item }">{{ formatarMoedaPtBr(item.saldoEmCarteira) }}</template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-4 grey lighten-5">
            <v-simple-table dense>
              <thead>
                <tr>
                  <th style="width: 140px;">Código Item</th>
                  <th>Descrição</th>
                  <th style="width: 120px;">Quantidade</th>
                  <th style="width: 160px;">Valor Total</th>
                </tr>
              </thead>
              <tbody v-if="item.itensQuantidade">
                <tr v-for="jobItem in item.itensJob" :key="jobItem._id">
                  <td>{{ jobItem.codigo || '-' }}</td>
                  <td>{{ jobItem.descricao || '-' }}</td>
                  <td>{{ formatarQuantidade(jobItem.quantidade) }}</td>
                  <td>{{ formatarMoedaPtBr(jobItem.valorTotal) }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td :colspan="4" class="text-center">Sem itens para este JOB</td>
                </tr>
              </tbody>
            </v-simple-table>
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import relatorioJobService from "@/views/Relatorios/services/relatorioJobService";
import {
  exportarExcel,
  exportarPdfTabela as exportarPdfTabular,
  formatarDataPtBr,
  formatarMoedaPtBr,
  normalizarTexto
} from "@/views/Relatorios/base/relatorioBaseUtils";

export default {
  name: "RelatorioComercialJobView",
  data() {
    return {
      loading: false,
      dados: [],
      expandidos: [],
      filtros: {
        dataInicio: "",
        dataFim: "",
        job: "",
        cliente: "",
        segmento: ""
      },
      headers: [
        { text: "CÓD./PED", value: "code" },
        { text: "Abertura", value: "dataAbertura" },
        { text: "Encerramento", value: "dataEncerramento" },
        { text: "Cliente", value: "clienteNome" },
        { text: "Descrição", value: "description" },
        { text: "Vend/Coord", value: "vendedorCoordenador" },
        { text: "Valor Job", value: "valorJob" },
        { text: "Valor Recebido", value: "valorRecebido" },
        { text: "Saldo a Receber", value: "saldoAReceber" },
        { text: "Valor Faturado", value: "valorFaturado" },
        { text: "Saldo em Carteira", value: "saldoEmCarteira" }
      ]
    };
  },
  computed: {
    dadosFiltrados() {
      const job = normalizarTexto(this.filtros.job).toLowerCase();
      const cliente = normalizarTexto(this.filtros.cliente).toLowerCase();
      const segmento = normalizarTexto(this.filtros.segmento).toLowerCase();

      return this.dados.filter((item) => {
        const codeOk = !job || normalizarTexto(item.code).toLowerCase().includes(job);
        const clienteOk = !cliente || normalizarTexto(item.clienteNome).toLowerCase().includes(cliente);
        const segmentoOk = !segmento || normalizarTexto(item.segmento).toLowerCase().includes(segmento);
        return codeOk && clienteOk && segmentoOk;
      });
    }
  },
  watch: {
    'filtros.dataInicio'() { this.buscarDados(); },
    'filtros.dataFim'() { this.buscarDados(); }
  },
  methods: {
    formatarDataPtBr,
    formatarMoedaPtBr,
    formatarQuantidade(valor) {
      return Number(valor || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4
      });
    },
    async buscarDados() {
      this.loading = true;
      try {
        const lista = await relatorioJobService.listarRelatorioJob(this.filtros);
        this.dados = Array.isArray(lista) ? lista : [];
        this.expandidos = [];
      } finally {
        this.loading = false;
      }
    },
    exportarXlsx() {
      const linhas = this.dadosFiltrados.map((item) => ({
        "CÓD./PED": `${item.code || "-"} / ${item.pedidoCompra || "-"}`,
        Abertura: this.formatarDataPtBr(item.dataAbertura),
        Encerramento: this.formatarDataPtBr(item.dataEncerramento),
        Cliente: item.clienteNome,
        Descrição: item.description,
        "Vend/Coord": item.vendedorCoordenador,
        "Valor Job": item.valorJob,
        "Valor Recebido": item.valorRecebido,
        "Saldo a Receber": item.saldoAReceber,
        "Valor Faturado": item.valorFaturado,
        "Saldo em Carteira": item.saldoEmCarteira
      }));

      exportarExcel(linhas, "relatorio-job.xlsx");
    },
    async exportarPdfTabela() {
      await exportarPdfTabular({
        headers: this.headers,
        rows: this.dadosFiltrados,
        nomeArquivo: "relatorio-job.pdf",
        tituloRelatorio: "Relatório de JOB",
        formatadoresPorCampo: {
          dataAbertura: (valor) => this.formatarDataPtBr(valor),
          dataEncerramento: (valor) => this.formatarDataPtBr(valor),
          valorJob: (valor) => this.formatarMoedaPtBr(valor),
          valorRecebido: (valor) => this.formatarMoedaPtBr(valor),
          saldoAReceber: (valor) => this.formatarMoedaPtBr(valor),
          valorFaturado: (valor) => this.formatarMoedaPtBr(valor),
          saldoEmCarteira: (valor) => this.formatarMoedaPtBr(valor)
        }
      });
    }
  },
  async mounted() {
    await this.buscarDados();
  }
};
</script>

<style scoped>
.c-filtro {
  max-width: 200px;
}
</style>
